import React from "react";
import he from "he";

const ProgramList = ({programs, properties}) => (

    <ul className={'program-list'}>
        {programs.map((p) => (
            <li className={'program-list__item'} key={p.id}>
                <a href={p.url}>
                    <div className={'program-list__item__labels'}>
                        {p.isEnglish && (
                            <span className={'program-list__item__label program-list__item__label--english'}>
                                {'In English'}
                            </span>
                        )}
                        {p.isOnline && (
                            <span className={'program-list__item__label program-list__item__label--digital'}>
                                Online
                            </span>
                        )}
                    </div>

                    <h3>{he.decode(p.title)}</h3>
                    <p dangerouslySetInnerHTML={{__html: p.description}}></p>
                    <p className={'program-list__item__date'}>
                        <strong>
                            {properties?.startDateLabel || 'Startdatum:'}
                        </strong>

                        {p.startDate && !isNaN(Date.parse(p.startDate)) ? (
                            <time dateTime={p.startDate}>{p.startDate}</time>
                        ) : (
                            p.startDate
                        )}
                    </p>
                </a>
            </li>
        ))}
    </ul>
);

export default ProgramList;
